import React from "react";

const SearchComponent = ({
  accountType,
  handleChange,
  handleLeadTypeChange,
  leadType,
  setFilterByObj,
  filterByObj,
}) => {

  const commonStyle = {
    // border: "1px solid",
    borderRadius: "5px",
    height: "40px",
    lineHeight: "1.5",
  };

  return (
    <>
      {/* Search */}
      <div className="col-12 col-md-3">
        <label className="form-label mb-1">Search Here</label>
        <input
          type="search"
          className="form-control shadow-none"
          placeholder="Search..."
          value={filterByObj.search || ""}
          onChange={(e) => {
            setFilterByObj({
              ...filterByObj,
              search: e.target.value,
            });
          }}
          // style={commonStyle}
            style={{ border: "1px Solid #8E3E63", width: "300px" }}
        />
      </div>

      {/* Account Type */}
      <div className="col-6 col-md-2">
        <label >Acc. Type</label>
        <select
          value={accountType}
          onChange={handleChange}
          className="form-select shadow-none"
          style={commonStyle}
        >
          <option value="">Select</option>
          <option value="B2B">B2B</option>
          <option value="B2C">B2C</option>
        </select>
      </div>

      {/* Lead Type */}
      <div className="col-6 col-md-2">
        <label>Lead Type</label>
        <select
          value={leadType}
          onChange={handleLeadTypeChange}
          className="form-select shadow-none"
          style={commonStyle}
        >
          <option value="">Select</option>
          <option value="Hot">Hot</option>
          <option value="Warm">Warm</option>
          <option value="Cold">Cold</option>
        </select>
      </div>
    </>
  );
};

export default SearchComponent;